var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "title" }, [
    _c("div", { staticClass: "text-topic" }, [
      _c("i", {
        staticClass: "text-warning",
        class: [_vm.notification_code_icon[_vm.code]]
      }),
      _vm._v(" "),
      _c("strong", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("notification_code." + _vm.code)) +
            "\n      -\n      " +
            _vm._s(_vm.$t("platform_code." + _vm.platform)) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-detail" }, [
      _c("div", [
        !["", "unknown"].includes(_vm.tableNumber)
          ? _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("apps.pos.message.tablenumber", {
                      ref_name: _vm.refName,
                      number: _vm.tableNumber
                    })
                  ) +
                  "\n      "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !["", "unknown"].includes(_vm.queueNumber)
          ? _c("span", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("apps.pos.message.queuenumber", {
                      number: _vm.queueNumber
                    })
                  ) +
                  "\n      "
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.orderDetail.length
        ? _c("div", [
            _c(
              "ul",
              _vm._l(_vm.orderDetail, function(order, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticStyle: { "list-style": "disc", "margin-left": "15px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("div", [
                          _vm._v(
                            "\n              " +
                              _vm._s(order.item) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(order.modifiers, function(modiName, modiIndex) {
                          return _c("div", { key: modiIndex }, [
                            _vm._v(
                              "\n              + " +
                                _vm._s(modiName) +
                                "\n            "
                            )
                          ])
                        })
                      ],
                      2
                    )
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "text-helper" }, [
      _c("span", { staticStyle: { color: "#ccc" } }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.getFriendlyTime(new Date(Number(_vm.dateTime)).toISOString())
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _vm.responseStatus === _vm.FIREBASE_NOTIFY_RESPONSE_STATUS.APPROVED
        ? _c("span", { staticClass: "text-success" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message.approved")) + "\n    ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.responseStatus === _vm.FIREBASE_NOTIFY_RESPONSE_STATUS.REJECTED
        ? _c("span", { staticClass: "text-danger" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("message.rejected")) + "\n    ")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0980e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0980e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseNotificationTitle.vue
// module id = null
// module chunks = 